module.exports = __webpack_public_path__ + "static/media/logothairunheaderleft.f46136ab.png";